// Выбор карточек сопоставления в прохождении: собранные пары живут в ответе
// экрана (их проверяет `checkAnswer`), а карточка, ждущая пару, — здесь: это
// состояние касания, а не ответ.
import { useState } from 'react'
import { matchPairs, setMatchPairs } from '../../preview/answerState'
import type { PreviewRun } from '../../preview/previewRun'
import { pickMatchItem, type MatchSelection, type MatchSide } from './matchPick'

export interface MatchPick {
  selection: MatchSelection
  pick: (side: MatchSide, id: number) => void
}

export const useMatchPick = (run: PreviewRun | undefined): MatchPick => {
  const [pending, setPending] = useState<MatchSelection['pending']>(null)
  const selection: MatchSelection = { pairs: run ? matchPairs(run.answer) : {}, pending }

  const pick = (side: MatchSide, id: number) => {
    if (!run || run.verdict) return
    const next = pickMatchItem(selection, side, id)
    setPending(next.pending)
    run.setAnswer(setMatchPairs(run.answer, next.pairs))
  }

  return { selection, pick }
}
